import { LAYOUT_OPTIONS } from '../../pages/image-editor-page/widgets/prompt-blocks/LayoutBlock';
import { ScriptData } from '../types/scriptTypes';
import { marked } from 'marked';
marked.setOptions({
    breaks: true,
});

export const formatScriptData = async (data: ScriptData): Promise<string> => {
    if (!data) return '';

    let formattedBody = data.body;

    formattedBody = await marked(data.body);
    formattedBody = formattedBody.replace(/\n+(?=<\/?(ul|ol|li|blockquote)>)/g, '');
    formattedBody = formattedBody.replace(/(<\/blockquote>)\n+/g, '$1');
    formattedBody = formattedBody.replace(/\n/g, '<br>');

    return formattedBody;
};

export function htmlToPlainText(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;

    div.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));

    div.querySelectorAll('p').forEach((p) => {
        const text = p.innerText.trim();
        if (text === '') {
            p.replaceWith('\n');
        } else {
            p.replaceWith(`${text}\n`);
        }
    });

    return div.innerText.trim();
}

export function formatDateToMonthDay(dateStr: string): string {
    const date = new Date(dateStr);

    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'long' });

    const getDaySuffix = (d: number) => {
        if (d >= 11 && d <= 13) return 'th';
        switch (d % 10) {
            case 1:
                return 'st';
            case 2:
                return 'nd';
            case 3:
                return 'rd';
            default:
                return 'th';
        }
    };

    return `${month} ${day}${getDaySuffix(day)}`;
}

export const formatDate = (dateString: string | undefined) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
};

export function getSlotCountBySlug(slug: string): number | undefined {
    const layout = LAYOUT_OPTIONS.find((option) => option.slug === slug);
    return layout?.slot_count;
}

export const stripHtml = (html: string): string => {
    return html.replace(/<[^>]+>/g, '');
};

export const formatHtmlToText = (html: string): string => {
    return html
        .replace(/<p>/g, '\n\n')
        .replace(/<\/p>/g, '')
        .replace(/<br\\?>/g, '\n')
        .replace(/<[^>]+>/g, '');
};

export const boldMarkdownToStrong = (text: string): string => {
    return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
};

export const markdownHeadersToHtml = (text: string): string => {
    return text
        .replace(/^###\s?(.*)$/gm, '<h3>$1</h3>')
        .replace(/^##\s?(.*)$/gm, '<h2>$1</h2>')
        .replace(/^#\s?(.*)$/gm, '<h1>$1</h1>');
};

const text = 'строка 1\nстрока 2\nстрока 3';
const html = marked.parse(text);
console.log(html);

export function decodeHtmlEntities(text: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
}

export function getShortTextFromHtml(html: string, maxLen = 400): string {
    const plainText = html.replace(/<[^>]*>/g, '');
    const decodedText = decodeHtmlEntities(plainText);
    if (decodedText.length > maxLen) {
        return decodedText.slice(0, maxLen - 3) + '...';
    }
    return decodedText;
}

export const getFirstActiveSocialMedia = (connections: any) => {
    if (!connections) return null;
    return Object.keys(connections).find((key) => connections[key] === true) || null;
};
